import React from 'react';
import { DropdownContextProvider } from './dropdown-context';
import MenuExpander from './menu-expander/menu-expander';
import Logo from './logo/logo';
import MainMenu, { MainMenuItems } from './main-menu/main-menu';
import { useToggle } from '~/helpers/data';
import cn from 'classnames';
import trapTab from '~/helpers/trap-tab';
import './menus.scss';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
export default function Menus() {
    const ref = React.useRef(null);
    const [active, toggleActive] = useToggle();
    const clickOverlay = React.useCallback((event) => {
        if (event.currentTarget === event.target) {
            toggleActive(false);
        }
    }, [toggleActive]);
    const closeOnEsc = React.useCallback((event) => {
        if (event.key === 'Escape') {
            toggleActive(false);
        }
    }, [toggleActive]);
    React.useEffect(() => {
        const tabListener = trapTab(ref.current);
        if (active) {
            document.addEventListener('keydown', tabListener, true);
        }
        else {
            document.removeEventListener('keydown', tabListener, true);
        }
        return () => window.removeEventListener('keydown', tabListener, true);
    }, [active]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DropdownContextProvider, null,
            React.createElement("div", { className: 'menus desktop' },
                React.createElement("nav", { className: 'nav', "aria-label": 'Main' },
                    React.createElement("div", { className: 'container' },
                        React.createElement(Logo, null),
                        React.createElement(MainMenu, null))))),
        React.createElement(DropdownContextProvider, { contextValueParameters: { prefix: 'mobile' } },
            React.createElement("div", { className: cn('menus mobile', { active }), ref: ref, onKeyDown: closeOnEsc },
                React.createElement(Logo, null),
                React.createElement(MenuExpander, { active: active, toggleActive: toggleActive, "aria-controls": 'menu-popover', "aria-expanded": active }),
                React.createElement("div", { className: 'menu-popover-overlay', onClick: clickOverlay },
                    React.createElement("div", { id: 'menu-popover', className: 'menu-popover' },
                        React.createElement("div", { className: 'menu-title' }, "Menu"),
                        React.createElement("ul", { className: 'no-bullets', onKeyDown: treatSpaceOrEnterAsClick },
                            React.createElement(MainMenuItems, null))))))));
}
